import axios from "../Axios/Default";
import { handleResponse } from "../Utils/Utils";

export const getAllApprovals = (_params, onSuccess, onError) => {
  // _params.orders = 'name:asc';
  const response = axios.get("v1/admin/approval", { params: _params });
  return handleResponse(response, onSuccess, onError);
};
